export default __webpack_public_path__ + "static/media/logo.efec8c84.png";